// extracted by mini-css-extract-plugin
module.exports = {"image":"Person_image__1eRVH","Person":"Person_Person__23wwX","nameText":"Person_nameText__hzq8D","nameTextDark":"Person_nameTextDark__2f9lP"};